
// Map of console commands to internal state keys
// Format: "command": { module: "moduleName", key: "internalKey", type: "string|float|int|boolean" }
export const COMMAND_MAP = {
    // Mouse
    'sensitivity': { module: 'mouse', key: 'sensitivity', type: 'float' },
    'zoom_sensitivity_ratio': { module: 'mouse', key: 'zoom_sensitivity_ratio', type: 'float' },
    'm_rawinput': { module: 'mouse', key: 'm_rawinput', type: 'boolean' },
    'm_yaw': { module: 'mouse', key: 'm_yaw', type: 'float' },
    'm_pitch': { module: 'mouse', key: 'm_pitch', type: 'float' },

    // Crosshair
    'cl_crosshairsize': { module: 'crosshair', key: 'cl_crosshairsize', type: 'float' },
    'cl_crosshairthickness': { module: 'crosshair', key: 'cl_crosshairthickness', type: 'float' },
    'cl_crosshairgap': { module: 'crosshair', key: 'cl_crosshairgap', type: 'float' },
    'cl_crosshairalpha': { module: 'crosshair', key: 'cl_crosshairalpha', type: 'int' },
    'cl_crosshaircolor_r': { module: 'crosshair', key: 'cl_crosshaircolor_r', type: 'int' },
    'cl_crosshaircolor_g': { module: 'crosshair', key: 'cl_crosshaircolor_g', type: 'int' },
    'cl_crosshaircolor_b': { module: 'crosshair', key: 'cl_crosshaircolor_b', type: 'int' },
    'cl_crosshairdot': { module: 'crosshair', key: 'cl_crosshairdot', type: 'boolean' },
    'cl_crosshair_drawoutline': { module: 'crosshair', key: 'cl_crosshair_drawoutline', type: 'boolean' },
    'cl_crosshair_outlinethickness': { module: 'crosshair', key: 'cl_crosshair_outlinethickness', type: 'float' },
    'cl_crosshairstyle': { module: 'crosshair', key: 'cl_crosshairstyle', type: 'int' },
    'cl_crosshair_recoil': { module: 'crosshair', key: 'cl_crosshair_recoil', type: 'boolean' },
    'cl_crosshair_t': { module: 'crosshair', key: 'cl_crosshair_t', type: 'boolean' },
    'cl_crosshair_friendly_warning': { module: 'crosshair', key: 'cl_crosshair_friendly_warning', type: 'int' },
    'cl_crosshair_sniper_width': { module: 'crosshair', key: 'cl_crosshair_sniper_width', type: 'int' },
    'cl_crosshaircolor': { module: 'crosshair', key: 'cl_crosshaircolor', type: 'int' }, // Special handling needed

    // Viewmodel
    'viewmodel_offset_x': { module: 'viewmodel', key: 'viewmodel_offset_x', type: 'float' },
    'viewmodel_offset_y': { module: 'viewmodel', key: 'viewmodel_offset_y', type: 'float' },
    'viewmodel_offset_z': { module: 'viewmodel', key: 'viewmodel_offset_z', type: 'float' },
    'viewmodel_fov': { module: 'viewmodel', key: 'viewmodel_fov', type: 'float' },
    'cl_prefer_lefthanded': { module: 'viewmodel', key: 'cl_prefer_lefthanded', type: 'boolean' }, // CS:GO, parsed as needed

    // HUD
    'cl_hud_color': { module: 'hud', key: 'cl_hud_color', type: 'int' },
    'hud_scaling': { module: 'hud', key: 'hud_scaling', type: 'float' },
    'cl_radar_scale': { module: 'hud', key: 'cl_radar_scale', type: 'float' },
    'cl_hud_radar_scale': { module: 'hud', key: 'cl_hud_radar_scale', type: 'float' },
    'cl_radar_always_centered': { module: 'hud', key: 'cl_radar_always_centered', type: 'boolean' },
    'cl_radar_rotate': { module: 'hud', key: 'cl_radar_rotate', type: 'boolean' },
    'cl_showloadout': { module: 'hud', key: 'cl_showloadout', type: 'boolean' },
    'cl_radar_icon_scale_min': { module: 'hud', key: 'cl_radar_icon_scale_min', type: 'float' },
    'cl_teammate_colors_show': { module: 'hud', key: 'cl_teammate_colors_show', type: 'int' },
    'cl_radar_opacity': { module: 'hud', key: 'cl_radar_opacity', type: 'float' }, // Custom?

    // Graphics
    'r_drawtracers_firstperson': { module: 'graphics', key: 'r_drawtracers_firstperson', type: 'boolean' },
    'r_dynamic': { module: 'graphics', key: 'r_dynamic', type: 'boolean' },
    'cl_allow_animated_avatars': { module: 'graphics', key: 'cl_allow_animated_avatars', type: 'boolean' },
    'engine_low_latency_sleep_after_client_tick': { module: 'graphics', key: 'engine_low_latency_sleep_after_client_tick', type: 'boolean' },
    'fps_max': { module: 'graphics', key: 'fps_max', type: 'int' },

    // Practice (some are client-side only for simulation, others are server commands)
    'sv_cheats': { module: 'practice', key: 'sv_cheats', type: 'boolean' },
}

// Map of bind commands to internal key keys
export const BIND_CMD_MAP = {
    // Movement
    '+forward': 'key_forward',
    '+back': 'key_back',
    '+left': 'key_left',
    '+right': 'key_right',
    '+sprint': 'key_walk', // CS2 default for shift usually, or +speed
    '+speed': 'key_walk',
    '+duck': 'key_duck',
    '+jump': 'key_jump',

    // Weapons
    '+attack': 'key_attack',
    '+attack2': 'key_attack2',
    '+reload': 'key_reload',
    '+use': 'key_use',
    'drop': 'key_drop',
    '+lookatweapon': 'key_inspect',
    'lastinv': 'key_lastinv',
    'buymenu': 'key_buymenu',
    'autobuy': 'key_autobuy',
    'rebuy': 'key_rebuy',

    // Slots
    'slot1': 'key_slot1',
    'slot2': 'key_slot2',
    'slot3': 'key_slot3',
    'slot4': 'key_slot4',
    'slot5': 'key_slot5',
    'slot6': 'grenade_he',      // Often HE
    'slot7': 'grenade_flash',   // Often Flash
    'slot8': 'grenade_smoke',   // Often Smoke
    'slot9': 'grenade_decoy',   // Often Decoy
    'slot10': 'grenade_molotov', // Often Molotov

    // Chat
    '+voicerecord': 'key_mic',
    'messagemode': 'key_chat',
    'messagemode2': 'key_chat_team',
    'player_ping': 'key_ping',
    'radio1': 'key_radio1',
    'radio2': 'key_radio2',
    'radio3': 'key_radio3',
    '+radialradio': 'key_radial_radio',
    '+radialradio2': 'key_radial_radio2',

    // Misc
    '+showscores': 'key_score',
    'toggleconsole': 'key_console',
    '+spray_menu': 'key_spray',
    '+cl_show_team_equipment': 'key_show_loadout',
    'teammenu': 'key_team_menu',
    'jpeg': 'key_screenshot',
    'quit': 'key_quit_prompt', // Usually linked to F10 confirm
    'sellbackall': 'key_sell_back_all',
    'invnext': 'key_inv_next',
    'invprev': 'key_inv_prev',
    'cancelselect': 'key_cancel_select',
}

// Map color indices (cl_crosshaircolor X) to their RGB values
const COLOR_MAP = {
    0: { r: 255, g: 0, b: 0 },
    1: { r: 0, g: 255, b: 0 },
    2: { r: 255, g: 255, b: 0 },
    3: { r: 0, g: 0, b: 255 },
    4: { r: 0, g: 255, b: 255 },
    // 5 is Custom, assume handled by explicit RGB commands
}

export function parseConfigFile(content) {
    const globalUpdates = {
        crosshair: {},
        mouse: {},
        viewmodel: {},
        hud: {},
        graphics: {},
        practice: {},
        binds: {}
    }

    // Split by lines or semicolons
    const lines = content.split(/[;\n]+/)

    lines.forEach(rawLine => {
        let line = rawLine.trim()
        if (!line || line.startsWith('//')) return

        // Remove double quotes around values
        // e.g. bind "w" "+forward" -> bind w +forward
        // BUT we must be careful with binds that might have multiple commands
        // For simplicity, we assume one command per bind line in simple CFGs, or simple clean up

        // Simple tokenizer
        // 1. Check if it's a bind
        if (line.toLowerCase().startsWith('bind')) {
            // parse bind
            // bind KEY COMMAND
            // regex: bind\s+"?(\S+)"?\s+"?(.+)"?
            const bindMatch = line.match(/^bind\s+"?([^"\s]+)"?\s+"?([^"]+)"?$/i)
            if (bindMatch) {
                const key = bindMatch[1].toLowerCase()
                const cmd = bindMatch[2].trim().toLowerCase()

                // If the command is a recognized bind
                // 1. Start with exact match
                let internalKey = BIND_CMD_MAP[cmd]

                // 2. Fallback: check if it contains multiple commands
                // We only support simple single-command binds for import primarily

                if (internalKey) {
                    globalUpdates.binds[internalKey] = key
                } else if (cmd.startsWith('buy ')) {
                    // Handle buy binds
                    // e.g. "buy ak47" -> key_buy_ak_full
                    const weapon = cmd.split(' ')[1]
                    const BUY_MAP = {
                        'ak47': 'key_buy_ak_full',
                        'm4a1': 'key_buy_m4_full',
                        'awp': 'key_buy_awp_full',
                        'deagle': 'key_buy_deagle'
                    }
                    if (BUY_MAP[weapon]) globalUpdates.binds[BUY_MAP[weapon]] = key
                }
            }
            return
        }

        // 2. Normal commands
        // Remove quotes for value parsing
        const cleanLine = line.replace(/"/g, '')
        const parts = cleanLine.split(/\s+/)
        const cmd = parts[0].toLowerCase()
        const valStr = parts.slice(1).join(' ')

        if (!valStr && valStr !== '0') return // No value

        const mapping = COMMAND_MAP[cmd]
        if (mapping) {
            let val = valStr
            if (mapping.type === 'float') val = parseFloat(valStr) || 0
            if (mapping.type === 'int') val = parseInt(valStr) || 0
            if (mapping.type === 'boolean') val = (valStr === '1' || valStr === 'true')

            // Special handling for cl_crosshaircolor
            if (cmd === 'cl_crosshaircolor') {
                const colorIndex = parseInt(valStr)
                if (COLOR_MAP[colorIndex]) {
                    const { r, g, b } = COLOR_MAP[colorIndex]
                    globalUpdates.crosshair.cl_crosshaircolor_r = r
                    globalUpdates.crosshair.cl_crosshaircolor_g = g
                    globalUpdates.crosshair.cl_crosshaircolor_b = b
                }
                globalUpdates.crosshair.cl_crosshaircolor = colorIndex
            } else {
                globalUpdates[mapping.module][mapping.key] = val
            }
        }
    })

    // Clean up empty modules
    Object.keys(globalUpdates).forEach(key => {
        if (Object.keys(globalUpdates[key]).length === 0) {
            delete globalUpdates[key]
        }
    })

    return globalUpdates
}
